module.exports = __webpack_public_path__ + "img/emails.1111ae97.svg";